import {formatDistanceToNow} from 'date-fns'

import ModeContext from '../../context/ModeContext'

import {LINK} from '../Videos/styledComponents'

import {
  VideoContainer,
  VideoImg,
  VideoCard,
  VideoTitle,
  VideoPara,
  VideoCardXs,
  VideoLogo,
  VideoText,
} from './styledComponents'

const TrendingVideo = props => {
  const {video} = props
  const {id, channel, publishedAt, thumbnailUrl, title, viewCount} = video
  const time = formatDistanceToNow(new Date(publishedAt))

  return (
    <ModeContext.Consumer>
      {value => {
        const {isDarkMode} = value
        const color = isDarkMode ? 'white' : '#212121'
        const paraColor = isDarkMode ? '#909090' : '#606060'

        return (
          <LINK to={`/videos/${id}`}>
            <VideoContainer>
              <VideoImg src={thumbnailUrl} alt="video thumbnail" />
              <VideoCard>
                <VideoTitle color={color}>{title}</VideoTitle>
                <VideoPara paraColor={paraColor}>{channel.name}</VideoPara>
                <VideoPara paraColor={paraColor}>
                  {viewCount} views • {time}
                </VideoPara>
              </VideoCard>
              <VideoCardXs>
                <VideoLogo src={channel.profileImageUrl} />
                <VideoText>
                  <VideoTitle color={color}>{title}</VideoTitle>
                  <VideoPara paraColor={paraColor}>
                    {channel.name} • {viewCount} views • {time}
                  </VideoPara>
                </VideoText>
              </VideoCardXs>
            </VideoContainer>
          </LINK>
        )
      }}
    </ModeContext.Consumer>
  )
}

export default TrendingVideo
